import * as React from 'react';

import * as styles from './FormCardLayout.css';

export const FormCardLayout = ({
  question,
  children,
  image,
  imageMobile,
  dataTestId,
}: {
  question: string;
  children: React.ReactNode;
  image: string;
  imageMobile: string;
  dataTestId?: string;
}) => {
  return (
    <div data-testid={dataTestId} className={styles['card']}>
      <div className={styles['form']}>
        <div className={styles['question']}>{question}</div>
        <div className={styles['content']}>{children}</div>
      </div>
      <div className={styles['image']}>
        <picture className={styles['picture']}>
          <source media="(max-width: 1023px)" srcSet={imageMobile} type="image/png" />
          <source media="(min-width: 102px)" srcSet={image} type="image/png" />
          <img src={imageMobile} alt={''} loading="lazy" decoding="async" />
        </picture>
      </div>
    </div>
  );
};
